import { render, staticRenderFns } from "./FeeSettings.vue?vue&type=template&id=a2ec8e8a"
import script from "./FeeSettings.vue?vue&type=script&lang=js"
export * from "./FeeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports